<template>
  <div class="low-sales-notice">
    <div v-if="shopName" class="low-sales-notice__shop">
      <span>授权店铺</span><strong>{{ shopName }}</strong>
    </div>

    <section class="low-sales-notice__cleanup">
      <i class="el-icon-delete" aria-hidden="true"></i>
      <div>
        <h3>开启后，系统将自动清理低效商品</h3>
        <p>低动销店铺：清理 <strong>7天无销量</strong> 商品</p>
        <span class="low-sales-notice__muted">仅针对通过本平台铺货的商品</span>
      </div>
    </section>

    <section class="low-sales-notice__restriction">
      <i class="el-icon-lock" aria-hidden="true"></i>
      <div>
        <h3>商品应用授权有效期间，不可关闭</h3>
        <p>开启后，在店铺商品应用授权有效且未到期期间，不可关闭“授权下架低效品”；应用授权失效或到期后方可关闭。</p>
      </div>
    </section>

    <section class="low-sales-notice__quota">
      <div class="low-sales-notice__heading">
        <h3>每日铺货额度</h3>
        <span class="low-sales-notice__off">未授权：0个 / 天</span>
      </div>
      <div class="low-sales-notice__table-wrap">
        <table class="low-sales-notice__table">
          <thead><tr><th scope="col">店铺状态</th><th scope="col">授权后每日额度</th></tr></thead>
          <tbody>
            <tr v-for="rule in quotaRules" :key="rule.key">
              <td>
                <span>{{ rule.shop }}</span>
                <span class="low-sales-notice__status" :class="{ 'low-sales-notice__status--qualified': rule.qualified }">{{ rule.qualified ? '动销达标' : '动销未达标' }}</span>
              </td>
              <td><strong class="low-sales-notice__amount">{{ rule.amount }}</strong><span class="low-sales-notice__unit"> 个 / 天</span><small>{{ rule.limit }}</small></td>
            </tr>
          </tbody>
        </table>
      </div>
      <p class="low-sales-notice__fallback">缺少必要额度数据时默认50个；已知低动销额度更低时按更低值执行，最低可为0。</p>
      <details class="low-sales-notice__details">
        <summary>额度如何计算？</summary>
        <p><strong>低动销额度（Q）</strong>：系统缓存的低动销店铺每日额度。</p>
        <p><strong>考核可铺数量（H）</strong>：根据本系统30天考核窗口内的在架商品数、有效动销商品数及旧快照后的铺货扣减计算。</p>
        <p>低动销未达标取 min(50, Q)，达标取 min(500, Q, H)；正常店铺未达标为300，达标取 min(500, H)。容量不足时可低于50，包括0。</p>
      </details>
    </section>

    <p class="low-sales-notice__consent">点击“{{ confirmLabel }}”，即表示您已了解额度规则，并同意上述自动清理及授权关闭限制。</p>
  </div>
</template>

<script>
export default {
  name: 'LowSalesAuthorizationNotice',
  props: {
    shopName: { type: String, default: '' },
    confirmLabel: { type: String, default: '同意并开启授权' }
  },
  data() {
    return {
      quotaRules: [
        { key: 'low-unqualified', shop: '低动销店铺', qualified: false, amount: '最多50', limit: '不超过低动销额度' },
        { key: 'low-qualified', shop: '低动销店铺', qualified: true, amount: '最多500', limit: '不超过低动销额度、考核可铺数量中的较小值' },
        { key: 'normal-unqualified', shop: '正常店铺', qualified: false, amount: '300', limit: '' },
        { key: 'normal-qualified', shop: '正常店铺', qualified: true, amount: '最多500', limit: '不超过考核可铺数量' }
      ]
    }
  }
}
</script>

<style scoped>
.low-sales-notice { color: #303744; font-size: 14px; line-height: 1.6; text-align: left; }
.low-sales-notice h3, .low-sales-notice p { margin: 0; }
.low-sales-notice h3 { font-size: 14px; font-weight: 600; }
.low-sales-notice__shop { display: flex; gap: 12px; align-items: baseline; margin-bottom: 16px; }
.low-sales-notice__shop > span { color: #7b8492; flex-shrink: 0; }
.low-sales-notice__shop strong { overflow-wrap: anywhere; }
.low-sales-notice__cleanup { display: flex; gap: 12px; padding: 16px; border: 1px solid #f2debc; border-radius: 8px; background: #fffbf3; }
.low-sales-notice__cleanup > i { color: #b77920; font-size: 20px; margin-top: 2px; }
.low-sales-notice__cleanup h3 { color: #80591e; margin-bottom: 4px; }
.low-sales-notice__cleanup p strong { color: #b66b12; }
.low-sales-notice__muted { color: #8a8070; font-size: 12px; }
.low-sales-notice__quota { margin: 20px 0; }
.low-sales-notice__heading { display: flex; justify-content: space-between; align-items: center; gap: 8px; margin-bottom: 10px; }
.low-sales-notice__off { font-size: 12px; color: #7b8492; padding: 2px 8px; background: #f2f4f7; border-radius: 4px; }
.low-sales-notice__table-wrap { border: 1px solid #e7ebf1; border-radius: 8px; overflow: hidden; }
.low-sales-notice__table { width: 100%; border-collapse: collapse; table-layout: fixed; }
.low-sales-notice__table th { background: #f7f8fa; font-weight: 500; font-size: 12px; color: #7b8492; text-align: left; padding: 9px 14px; }
.low-sales-notice__table th:first-child { width: 43%; }
.low-sales-notice__table td { padding: 10px 14px; border-top: 1px solid #edf0f4; vertical-align: middle; }
.low-sales-notice__table td:first-child > span:first-child { display: inline-block; margin-right: 8px; }
.low-sales-notice__status { display: inline-block; padding: 1px 6px; font-size: 11px; color: #8b7290; background: #f4f0f5; border-radius: 4px; white-space: nowrap; }
.low-sales-notice__status--qualified { color: #438566; background: #edf7f1; }
.low-sales-notice__amount { font-size: 17px; font-weight: 600; color: #303744; }
.low-sales-notice__unit { font-size: 12px; color: #7b8492; }
.low-sales-notice__table small { display: block; color: #7b8492; font-size: 12px; line-height: 1.5; }
.low-sales-notice .low-sales-notice__fallback { margin-top: 10px; font-size: 12px; color: #7b8492; }
.low-sales-notice__details { margin-top: 8px; font-size: 12px; color: #7b8492; }
.low-sales-notice__details summary { color: #596779; cursor: pointer; width: fit-content; }
.low-sales-notice__details p { margin-top: 6px; }
.low-sales-notice__restriction { margin-top: 14px; display: flex; gap: 10px; padding: 13px 14px; border: 1px solid #f1d6d3; background: #fff7f6; border-radius: 8px; }
.low-sales-notice__restriction > i { font-size: 18px; margin-top: 2px; color: #bd5950; }
.low-sales-notice__restriction h3 { color: #a64f47; margin-bottom: 4px; }
.low-sales-notice__restriction p { font-size: 12px; color: #896560; }
.low-sales-notice .low-sales-notice__consent { margin-top: 14px; font-size: 12px; color: #7b8492; }
@media (max-width: 520px) {
  .low-sales-notice__table th, .low-sales-notice__table td { padding: 9px 10px; }
  .low-sales-notice__status { margin-top: 3px; }
  .low-sales-notice__table th:first-child { width: 39%; }
  .low-sales-notice__amount { font-size: 16px; }
  .low-sales-notice__cleanup { padding: 12px; }
}
</style>

<style>
.low-sales-authorization-dialog.el-dialog { width: 740px; max-width: calc(100vw - 32px); border-radius: 12px; overflow: hidden; }
.low-sales-authorization-dialog .el-dialog__header { padding: 22px 24px 16px; border-bottom: 1px solid #edf0f4; }
.low-sales-authorization-dialog .el-dialog__title { color: #303744; font-size: 18px; font-weight: 600; }
.low-sales-authorization-dialog .el-dialog__headerbtn { top: 25px; right: 24px; }
.low-sales-authorization-dialog .el-dialog__body { padding: 18px 24px; max-height: calc(100vh - 200px); overflow-y: auto; }
.low-sales-authorization-dialog .el-dialog__footer { padding: 14px 24px 18px; border-top: 1px solid #edf0f4; }
.low-sales-authorization-confirm.el-message-box { width: 680px; max-width: calc(100vw - 32px); padding: 0; border-radius: 12px; }
.low-sales-authorization-confirm .el-message-box__header { padding: 22px 24px 16px; border-bottom: 1px solid #edf0f4; }
.low-sales-authorization-confirm .el-message-box__title { font-family: inherit; font-size: 18px; font-weight: 600; }
.low-sales-authorization-confirm .el-message-box__headerbtn { top: 25px; right: 24px; }
.low-sales-authorization-confirm .el-message-box__content { padding: 18px 24px; }
.low-sales-authorization-confirm .el-message-box__message { max-height: calc(100vh - 210px); overflow-y: auto; }
.low-sales-authorization-confirm .el-message-box__message > p { margin: 0; line-height: inherit; }
.low-sales-authorization-confirm .el-message-box__btns { padding: 14px 24px 18px; border-top: 1px solid #edf0f4; }
@media (max-width: 520px) {
  .low-sales-authorization-dialog .el-dialog__header, .low-sales-authorization-confirm .el-message-box__header { padding: 18px 16px 14px; }
  .low-sales-authorization-dialog .el-dialog__body, .low-sales-authorization-confirm .el-message-box__content { padding: 16px; }
  .low-sales-authorization-dialog .el-dialog__footer, .low-sales-authorization-confirm .el-message-box__btns { padding: 12px 16px 16px; }
}
</style>
